<template>
  <div>
    <div class="bgImg">
      <div class="title">
        <div class="title-cover">
          <img
            v-if="courseInfo.coverUrl"
            :src="courseInfo.coverUrl"
            class="coverImg"
          />
          <img
            v-else
            src="../../../public/gateway/course/defaultImg.png"
            class="coverImg"
          />
        </div>
        <div class="title-name">{{ courseInfo.courseName }}</div>
      </div>
    </div>
    <div class="box"></div>
    <div class="detail">
      <div class="detail-box">
        <div class="apply">
          <img src="../../../public/gateway/course/icon@2x.png" />
          <div class="apply-box">
            <div class="box-title">申请开班</div>
            <div class="box-content">为您的孩子申请开设此课程的班级</div>
          </div>
          <div @click="openModal()" class="apply-btn">申请开班</div>
        </div>
        <div class="course">
          <div class="course-box">
            <div class="box-title">课程简介</div>
            <div v-html="courseInfo.intro" class="box-list"></div>
          </div>
          <div class="course-box">
            <div class="box-title">课程大纲</div>
            <div class="box-list">
              <a-timeline>
                <a-timeline-item
                  v-for="(item, index) in courseInfo.courseLesson"
                  :key="index"
                >
                  <div slot="dot" class="box-list-dot"></div>
                  <div class="box-list-title">
                    {{ index + 1 }}.{{ item.title }}
                  </div>
                  <div class="box-list-content">{{ item.content }}</div>
                </a-timeline-item>
              </a-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="popup">
      <div class="modal">
        <img
          src="../../../public/gateway/course/close@2x.png"
          @click="close()"
          class="close"
        />
        <img v-if="qrcode" :src="qrcode" class="qrcode" />
        <img
          v-else
          src="../../../public/gateway/parent/parentMP.jpg"
          class="qrcode"
        />
        <div>请用微信扫码进行开班申请</div>
      </div>
    </div>
  </div>
</template>

<script>
import gateway from '../../api/gateway'

export default {
  name: 'index',
  data() {
    return {
      courseId: '',
      courseInfo: {},
      show: false,
      qrcode: '',
    }
  },
  created() {
    if (this.$route.query.id) this.courseId = this.$route.query.id
    this.getCourseDetail()
    this.getQRCode()
  },
  methods: {
    getCourseDetail() {
      gateway
        .getCourseDetail({
          id: this.courseId,
        })
        .then((res) => {
          this.courseInfo = res.data
        })
        .catch((err) => {
          this.$message.error('未找到当前课程详情')
          setTimeout(() => {
            this.$router.push('/school/portal')
          }, 2000)
        })
    },
    getQRCode() {
      gateway.getQRCode().then((res) => {
        this.qrcode = res.data
      })
    },
    openModal() {
      this.show = true
    },
    close() {
      this.show = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';

@media screen and (min-width: 510px) {
  .bgImg {
    width: 100%;
    height: 360px;
    padding: 131px 0 0;
    background: url('../../../public/gateway/course/detail_bgImg@2x.png')
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      width: 100%;
      max-width: 1100px;
      @media screen and (min-width: 1441px) {
        max-width: 1500px;
      }
      display: flex;
      align-items: center;

      .title-cover {
        width: 560px;
        height: 316px;
        border: 3px solid #ffffff;
        border-radius: 25px;
        position: relative;

        .coverImg {
          width: 100%;
          height: 100%;
          border-radius: 25px;
          top: 0;
          left: 0;
          position: absolute;
          object-fit: cover;
        }
      }

      .title-name {
        flex: 1;
        font-size: 48px;
        color: #ffffff;
        margin-left: 38px;
      }
    }
  }

  .box {
    height: 100px;
    background-color: #f7f7f7;
  }

  .detail {
    width: 100%;
    padding: 0 0 80px;
    background-color: #f7f7f7;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    .detail-box {
      width: 100%;
      max-width: 1100px;
      @media screen and (min-width: 1441px) {
        max-width: 1500px;
      }
      .apply {
        width: 100%;
        height: 180px;
        padding: 0 40px;
        background-color: #ffffff;
        border-radius: 10px;
        display: flex;
        align-items: center;

        img {
          width: 127px;
          height: 121px;
        }

        .apply-box {
          flex: 1;
          color: #333333;
          margin: 0 33px;

          .box-title {
            width: 100%;
            font-size: 36px;
            font-weight: 600;
          }

          .box-content {
            width: 100%;
            font-size: 18px;
            margin-top: 8px;
          }
        }

        .apply-btn {
          width: 208px;
          height: 68px;
          font-size: 24px;
          color: #ffffff;
          font-weight: 600;
          background-color: #fe3901;
          border-radius: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }

      .course {
        width: 100%;
        margin-top: 24px;
        display: flex;
        justify-content: space-between;

        .course-box {
          width: 49%;
          background-color: #f4f8fc;

          .box-title {
            width: 100%;
            height: 97px;
            font-size: 24px;
            color: #333333;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .box-list {
            width: 100%;
            min-height: 500px;
            padding: 30px 20px;
            background-color: #ffffff;
            margin-top: 6px;

            // overflow-y: scroll;
            // overflow-x: hidden;
            ::v-deep img {
              max-width: 100%;
            }

            .box-list-dot {
              width: 12px;
              height: 12px;
              background-color: #35c794;
              border-radius: 50px;
              margin-top: 8px;
            }

            .box-list-title {
              font-size: 22px;
            }

            .box-list-content {
              width: 100%;
              padding: 20px;
              background-color: #f4f7fd;
              margin-top: 16px;
            }
          }

          ::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
  }

  .popup {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    position: fixed;

    .modal {
      width: 600px;
      height: 520px;
      font-size: 19px;
      color: #666666;
      background-color: #ffffff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      .close {
        width: 20px;
        height: 20px;
        top: 20px;
        right: 20px;
        position: absolute;
      }

      .qrcode {
        width: 284px;
        height: 284px;
        border-radius: 10px;
        margin-bottom: 30px;
      }
    }
  }
}

@media screen and (max-width: 510px) {
  .bgImg {
    width: 100%;
    height: 80px;
    padding: 40px 20px 0;
    background: url('../../../public/gateway/course/detail_bgImg@2x.png')
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .title {
      width: 100%;
      display: flex;
      align-items: center;

      .title-cover {
        width: 120px;
        height: 68px;
        border: 2px solid #ffffff;
        border-radius: 8px;
        position: relative;

        .coverImg {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          top: 0;
          left: 0;
          position: absolute;
          object-fit: cover;
        }
      }

      .title-name {
        flex: 1;
        font-size: 20px;
        color: #ffffff;
        margin-left: 18px;
      }
    }
  }

  .box {
    height: 30px;
    background-color: #f7f7f7;
  }

  .detail {
    width: 100%;
    padding: 0 20px 80px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;

    .detail-box {
      width: 100%;
      .apply {
        width: 100%;
        height: 80px;
        padding: 0 15px;
        background-color: #ffffff;
        border-radius: 5px;
        display: flex;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
        }

        .apply-box {
          flex: 1;
          color: #333333;
          margin: 0 15px;

          .box-title {
            width: 100%;
            font-size: 12px;
            font-weight: 600;
          }

          .box-content {
            width: 100%;
            font-size: 12px;
            margin-top: 4px;
          }
        }

        .apply-btn {
          width: 70px;
          height: 28px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 600;
          background-color: #fe3901;
          border-radius: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .course {
        width: 100%;

        .course-box {
          width: 100%;
          background-color: #f4f8fc;
          margin-top: 12px;

          .box-title {
            width: 100%;
            height: 50px;
            font-size: 18px;
            color: #333333;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .box-list {
            width: 100%;
            min-height: 300px;
            // max-height: 1200px;
            padding: 20px 10px;
            background-color: #ffffff;
            margin-top: 4px;

            // overflow-y: scroll;
            // overflow-x: hidden;

            ::v-deep img {
              max-width: 100%;
            }

            .box-list-dot {
              width: 8px;
              height: 8px;
              background-color: #35c794;
              border-radius: 50px;
              margin-top: 2px;
            }

            .box-list-title {
              font-size: 16px;
            }

            .box-list-content {
              width: 100%;
              padding: 10px;
              background-color: #f4f7fd;
              margin-top: 8px;
            }
          }

          ::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
  }

  .popup {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    position: fixed;

    .modal {
      width: 300px;
      height: 300px;
      font-size: 14px;
      color: #666666;
      background-color: #ffffff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;

      .close {
        width: 20px;
        height: 20px;
        top: 15px;
        right: 15px;
        position: absolute;
      }

      .qrcode {
        width: 142px;
        height: 142px;
        border-radius: 10px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
